export function getLocalStorage(key) {
  try {
    const itemStr = localStorage.getItem(key)
    return JSON.parse(itemStr)
  } catch {
    return null
  }
}
